import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
  Box,
  Button,
  Chip,
  FormControlLabel,
  IconButton,
  Stack,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { isGst, newLine } from "./moduleInvoiceForm";

const InvoiceLineItemsEditor = ({ lines, onChange }) => {
  const update = (key, field, value) =>
    onChange(lines.map((line) => (line.key === key ? { ...line, [field]: value } : line)));

  return (
    <Stack spacing={1.5}>
      <Typography variant="subtitle2" fontWeight={700}>
        Lines
      </Typography>
      {lines.map((line) => (
        <Stack
          key={line.key}
          direction={{ xs: "column", md: "row" }}
          spacing={1}
          alignItems={{ md: "center" }}
        >
          <TextField
            label="Description"
            size="small"
            fullWidth
            value={line.description}
            onChange={(e) => update(line.key, "description", e.target.value)}
            InputProps={{
              endAdornment: line.chargeKey ? (
                <Chip size="small" variant="outlined" label="from charges" />
              ) : null,
            }}
          />
          <TextField
            label="Qty"
            type="number"
            size="small"
            sx={{ width: { md: 90 } }}
            inputProps={{ min: 1, step: 1 }}
            value={line.quantity}
            onChange={(e) => update(line.key, "quantity", e.target.value)}
          />
          <TextField
            label="Price"
            type="number"
            size="small"
            sx={{ width: { md: 130 } }}
            inputProps={{ step: "0.01" }}
            value={line.price}
            onChange={(e) => update(line.key, "price", e.target.value)}
          />
          <FormControlLabel
            label="GST"
            control={
              <Switch
                size="small"
                checked={isGst(line.gst)}
                onChange={(e) => update(line.key, "gst", e.target.checked ? "yes" : "no")}
              />
            }
          />
          <Tooltip title="Remove line">
            <IconButton
              size="small"
              aria-label="Remove line"
              onClick={() => onChange(lines.filter((item) => item.key !== line.key))}
            >
              <DeleteOutlineIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      ))}
      <Box>
        <Button
          size="small"
          startIcon={<AddIcon />}
          onClick={() => onChange([...lines, newLine()])}
        >
          Add line
        </Button>
      </Box>
    </Stack>
  );
};

export default InvoiceLineItemsEditor;
